module.exports = __webpack_public_path__ + "img/630.c2e60f17.png";